import cloneDeep from 'lodash/cloneDeep';
import pick from 'lodash/pick';
import merge from 'lodash/merge';
import isEmpty from 'lodash/isEmpty';
import throttle from 'lodash/throttle';
import { getEnvironment } from '../utils';

export const mergeWithCachedStore = (
	//eslint-disable-next-line @typescript-eslint/no-explicit-any
	store: { [x: string]: any } = {},
) => {
	const clonedStore = cloneDeep(store);
	try {
		const cachedLocalStore = localStorage.getItem(
			`INFO_360_${getEnvironment()}`,
		);
		const cachedSessionStore = sessionStorage.getItem(
			`INFO_360_${getEnvironment()}`,
		);
		if (cachedLocalStore && cachedSessionStore)
			return merge(
				JSON.parse(cachedLocalStore),
				JSON.parse(cachedSessionStore),
				clonedStore,
			);
		else if (cachedLocalStore)
			return merge(JSON.parse(cachedLocalStore), clonedStore);
		else if (cachedSessionStore)
			return merge(JSON.parse(cachedSessionStore), clonedStore);
		else if (!isEmpty(clonedStore)) return clonedStore;
	} catch (error) {
		console.log(
			`Something went wrong reading from localStorage cache: ${error}`,
		);
		if (!isEmpty(clonedStore)) return clonedStore;
	}
	return undefined;
};

export const cacheStore = (
	//eslint-disable-next-line @typescript-eslint/no-explicit-any
	store: { [x: string]: any } = {},
	localReducerNames: string[] = [],
	sessionReducerNames: string[] = [],
): void => {
	const localStoreToBeCached = pick(store, localReducerNames);
	const sessionStoreToBeCached = pick(store, sessionReducerNames);
	try {
		localStorage.setItem(
			`INFO_360_${getEnvironment()}`,
			JSON.stringify(localStoreToBeCached),
		);
		sessionStorage.setItem(
			`INFO_360_${getEnvironment()}`,
			JSON.stringify(sessionStoreToBeCached),
		);
	} catch (error) {
		console.log(`Something went wrong caching to localStorage: ${error}`);
	}
};

const throttledCacheStore = throttle(
	(
		//eslint-disable-next-line @typescript-eslint/no-explicit-any
		store: { [x: string]: any } = {},
		localReducerNames: string[] = [],
		sessionReducerNames: string[] = [],
	) => cacheStore(store, localReducerNames, sessionReducerNames),
	1000,
);

export const handleCacheStore = (
	//eslint-disable-next-line @typescript-eslint/no-explicit-any
	store: { [x: string]: any } = {},
	localReducerNames: string[] = [],
	sessionReducerNames: string[] = [],
) => throttledCacheStore(store, localReducerNames, sessionReducerNames);
